import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useLayout } from '@/composables/core/useLayout';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isTablet } = useLayout();
const currentYear = computed(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["caption opacity-50", _unref(isTablet) ? 'text-left' : 'text-center'])
  }, " © Blueshift 2021-" + _toDisplayString(_unref(currentYear)) + ". All rights reserved. ", 3))
}
}

})